import { render } from "./skeleton.vue?vue&type=template&id=0dd754de&name=skeleton"
const script = {}

import "./skeleton.vue?vue&type=style&index=0&id=0dd754de&lang=less"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__